import { QuoteStatusesType } from "@/common/const/quote/quoteStatuses.const";
import { axiosInstance } from "../../axios";
import { useMutation } from "@tanstack/react-query";

const changeQuoteStatus = async (
  quoteId: string,
  quoteStatus: QuoteStatusesType
) => {
  return await axiosInstance
    .patch(`quotes/status/${quoteId}`, { quoteStatus })
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};
const useUpdateQuoteStatus = () => {
  return useMutation({
    mutationKey: ["quotes"],
    mutationFn: ({
      quoteId,
      quoteStatus,
    }: {
      quoteId: string;
      quoteStatus: QuoteStatusesType;
    }) => changeQuoteStatus(quoteId, quoteStatus),
  });
};
export default useUpdateQuoteStatus;
